export enum RejectonTypes {
  ITEM_ISSUE = "ITEM_ISSUE",
  KITCHEN_CLOSED = "KITCHEN_CLOSED",
  RESTAURANT_TOO_BUSY = "RESTAURANT_TOO_BUSY",
  ORDER_VALIDATION = "ORDER_VALIDATION",
  STORE_CLOSED = "STORE_CLOSED",
  TECHNICAL_FAILURE = "TECHNICAL_FAILURE",
  UNKNOWN = "UNKNOWN",
  OTHER = "OTHER",
}
type RejectonOption = {
  label: string;
  value: string;
};
const convertEnumToArray = (enumObject: any): RejectonOption[] => {
  return Object.keys(enumObject).map((key) => ({
    label: key.toLowerCase(),
    value: enumObject[key],
  }));
};
// Example usage
export const rejectionOptions: RejectonOption[] =
  convertEnumToArray(RejectonTypes);
export type DenyReason = {
  deny_reason: string;
  branchId: number;
  deny_type: typeof RejectonTypes;
};
